import { render, staticRenderFns } from "./TabModeratorAccountClassroomStudent.vue?vue&type=template&id=c0adbdbc&"
import script from "./TabModeratorAccountClassroomStudent.vue?vue&type=script&lang=js&"
export * from "./TabModeratorAccountClassroomStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports